import { createContext, ReactNode, useContext, useState } from "react";
import { Profile } from "../../types/Profile";

type ProfileDataContextProps = {
	profileData?: Profile;
	setProfileData: React.Dispatch<React.SetStateAction<Profile | undefined>>;
};

const ProfileDataContext = createContext<ProfileDataContextProps | undefined>(undefined);

export const ProfileDataProvider = ({
	children,
	initialProfile,
}: {
	children: ReactNode;
	initialProfile?: Profile;
}) => {
	const [profileData, setProfileData] = useState<Profile | undefined>(initialProfile);

	return (
		<ProfileDataContext.Provider
			value={{
				profileData,
				setProfileData,
			}}
		>
			{children}
		</ProfileDataContext.Provider>
	);
};

export const useProfileData = () => {
	const ctx = useContext(ProfileDataContext);
	if (!ctx) throw new Error("useProfileData should be used inside of <ProfileDataProvider>");
	return ctx;
};
